import { MODULE_LABELS } from "@/lib/api";

export const ALL_MODULES = Object.keys(MODULE_LABELS);

export const LIMITS = [["users", "Usuários ativos"], ["products", "Produtos"], ["orders", "Pedidos por mês"], ["stores", "Unidades"]];

export const SETTING_GROUPS = [
  { mod: "pdv", title: "PDV / Caixa", fields: [["max_discount_pct", "Desconto máximo (%)", "num"]] },
  { mod: "mesas", title: "Mesas e comandas", fields: [["service_fee_pct", "Taxa de serviço (%)", "num"]] },
  { mod: "delivery", title: "Delivery", fields: [["delivery_enabled", "Delivery ativo", "bool"], ["delivery_fee", "Taxa de entrega padrão (R$)", "num"], ["min_order", "Pedido mínimo (R$)", "num"], ["default_eta", "Prazo padrão (min)", "int"]] },
  { mod: "estacionamento", title: "Estacionamento", fields: [["parking_first_hour", "1ª hora (R$)", "num"], ["parking_additional_hour", "Hora adicional (R$)", "num"], ["parking_tolerance_min", "Tolerância (min)", "int"], ["parking_daily_max", "Diária máxima (R$)", "num"]] },
  { mod: "estoque", title: "Estoque", fields: [["stock_negative", "Venda sem estoque", [["allow", "Permitir com alerta"], ["block", "Bloquear"]]]] },
  { mod: "cardapio", title: "Cardápio digital", fields: [["menu_enabled", "Receber pedidos pelo cardápio", "bool"]] },
];

export const SETTING_KEYS = SETTING_GROUPS.flatMap((g) => g.fields.map((f) => f[0]));
